<template>
    <a-row>
        <a-col :span="8">
            <a-card>
                <a-list
                    itemLayout="vertical"
                    size="large"
                    :dataSource="listData"
                >
                    <a-list-item
                        slot="renderItem"
                        slot-scope="item"
                        key="item.title"
                    >
                        <a-list-item-meta :description="item.description">
                            <a slot="title" :href="item.href">
                                <a-icon type="form" />
                                {{ item.title }}
                            </a>
                        </a-list-item-meta>
                        {{ item.content }}
                        <template slot="actions">
                            <a-button type="primary">Open form</a-button>
                        </template>
                        <div slot="footer">
                            <b>ant design vue</b> footer part
                        </div>
                    </a-list-item>
                </a-list>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
const listData = []
for (let i = 0; i < 5; i++) {
    listData.push({
        href: 'https://vue.ant.design/',
        title: `ant design vue part ${i}`,
        avatar:
            'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
        description:
            'Ant Design, a design language for background applications, is refined by Ant UED Team.',
        content:
            'We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.',
    })
}

export default {
    data() {
        return {
            listData,
        }
    },
}
</script>
<style></style>
